// Invoice Analyser: dropzone, processing checklist, the extraction card, the
// audit trail and the history panel.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const analyser: Record<string, string> = {
  'Refresh history': 'Verlauf aktualisieren',

  // Dropzone
  'Drop invoice here or click to browse': 'Rechnung hierher ziehen oder klicken zum Auswählen',
  'max 10 MB': 'max. 10 MB',
  'Uploading document …': 'Dokument wird geladen …',
  'Please wait': 'Bitte warten',
  'Invalid file type. Please upload PDF, PNG, JPG or XML.':
    'Ungültiger Dateityp. Bitte PDF, PNG, JPG oder XML hochladen.',
  'File too large. Maximum size is 10 MB.': 'Datei zu groß. Maximal 10 MB.',

  // ProcessingStatus
  Processing: 'Verarbeitung',
  'Processing failed': 'Verarbeitung fehlgeschlagen',
  'Processing failed.': 'Verarbeitung fehlgeschlagen.',
  'Document uploaded': 'Dokument geladen',
  'Document type recognised': 'Dokumenttyp erkannt',
  'Data extracted': 'Daten extrahiert',
  'Extraction checked': 'Extraktion geprüft',
  'Result ready': 'Ergebnis fertig',
  done: 'fertig',
  'running …': 'läuft …',

  // ExtractionResult
  'Extracted data': 'Erkannte Daten',
  'Edit fields': 'Felder bearbeiten',
  'Stop editing': 'Bearbeitung beenden',
  'Show tax details': 'Steuerdetails anzeigen',
  'Hide tax details': 'Steuerdetails ausblenden',
  'Document type': 'Belegart',
  'Open audit trail': 'Audit Trail öffnen',
  'Stored in EUR — historical rate of': 'Wird in EUR gespeichert — historischer Kurs vom',
  'Not detected': 'Nicht erkannt',
  'No source': 'Beleg fehlt',
  'Add to the supplier whitelist': 'Zur Lieferanten-Whitelist hinzufügen',
  'Add to the recipient whitelist': 'Zur Empfänger-Whitelist hinzufügen',
  'VAT breakdown': 'Aufteilung Umsatzsteuer',
  'Tax-free breakdown': 'Aufteilung steuerfrei',
  Category: 'Kategorie',
  Rate: 'Satz',
  Basis: 'Bemessung',
  Tax: 'Steuer',
  'Mapping to PO': 'PO-Zuordnung',
  'loading POs …': 'POs werden geladen …',
  'no POs available': 'keine POs vorhanden',
  'no PO': 'kein PO',
  'list not loaded': 'Liste nicht geladen',
  'please choose': 'bitte wählen',
  'Add to database': 'In die Datenbank',
  'Push to Flixpector': 'An Flixpector übergeben',
  'Handing over …': 'Wird übergeben …',
  'Hand over to Flixpector for review — then appears in the Inbox under "With Flixpector"':
    'Zur Prüfung an Flixpector übergeben — erscheint danach in der Inbox unter „Bei Flixpector“',

  // Page-level messages
  '"{name}" added to the supplier whitelist': '„{name}“ zur Lieferanten-Whitelist hinzugefügt',
  '"{name}" added to the recipient whitelist': '„{name}“ zur Empfänger-Whitelist hinzugefügt',
  'Could not add the supplier': 'Der Lieferant konnte nicht hinzugefügt werden',
  'Could not add the recipient': 'Der Empfänger konnte nicht hinzugefügt werden',
  'Added to the database': 'In die Datenbank übernommen',
  'Could not add to the database': 'Übernahme in die Datenbank fehlgeschlagen',
  'No document to hand over — please upload again':
    'Kein Dokument zum Übergeben — bitte neu hochladen',
  'Handed over to Flixpector — now in the Inbox under "With Flixpector".':
    'An Flixpector übergeben — liegt jetzt in der Inbox unter „Bei Flixpector“.',
  'Handed over, but the analysis in Flixpector did not start — trigger it there.':
    'Übergeben, aber die Analyse in Flixpector startete nicht — dort erneut anstoßen.',
  'Hand-over failed': 'Übergabe fehlgeschlagen',

  // EvidenceDialog
  '{n} of {total} fields with a source passage': '{n} von {total} Feldern mit Fundstelle',
  'No passage found in the document — the value is not from the text.':
    'Keine Fundstelle im Dokument — der Wert stammt nicht aus dem Text.',
  'Not found in the document — can be filled in from the supplier whitelist.':
    'Nicht im Dokument gefunden — kann aus der Lieferanten-Whitelist ergänzt werden.',

  // HistoryPanel
  History: 'Verlauf',
  '{n} recently analysed documents': '{n} zuletzt analysierte Belege',
  'No processed documents yet — upload an invoice.':
    'Noch keine verarbeiteten Dokumente — lade eine Rechnung hoch.',
  'No supplier recognised': 'Kein Lieferant erkannt',
  Done: 'Fertig',
  Running: 'Läuft',
  Waiting: 'Wartet',
  Error: 'Fehler',

  // DuplicateWarning
  'Possible duplicate invoice': 'Potenzielle doppelte Rechnung',
  'Add anyway': 'Trotzdem übernehmen',
  '(no number)': '(ohne Nummer)',
  '(no supplier)': '(ohne Lieferant)',
  from: 'von',
  'is already in the database.': 'liegt schon in der Datenbank.',
  'Show the existing invoice': 'Vorhandene Rechnung anzeigen',
}
